"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PartnerReferenceKey = exports.partnerReferenceKeys = exports.referenceKeys = exports.ReferenceKey = void 0;
var ReferenceKey;
(function (ReferenceKey) {
    ReferenceKey["accountEmail"] = "account_email";
    ReferenceKey["accountName"] = "account_name";
    ReferenceKey["accountPhoneNumber"] = "account_phoneNumber";
    ReferenceKey["accountPreferredLocale"] = "account_preferredLocale";
    ReferenceKey["accountEmployeeId"] = "account_employeeId";
    ReferenceKey["accountPassword"] = "account_password";
    ReferenceKey["accountEnterpriseId"] = "account_enterpriseId";
    ReferenceKey["accountOrganizationId"] = "account_organizationId";
    ReferenceKey["accountAddress"] = "account_address";
    ReferenceKey["accountOfficeId"] = "account_officeId";
    ReferenceKey["commuteProfileArrive"] = "commuteProfile_arriveOfficeTime";
    ReferenceKey["commuteProfileVehicleId"] = "commuteProfile_vehicleId";
    ReferenceKey["commuteProfileLeave"] = "commuteProfile_leaveOfficeTime";
    ReferenceKey["commuteProfileRoute"] = "commuteProfile_route";
    ReferenceKey["commuteProfileRemoteFrequency"] = "commuteProfile_remoteFrequency";
    ReferenceKey["commuteProfileFrequency"] = "commuteProfile_frequency";
    ReferenceKey["commuteProfilePeopleCountRidesharing"] = "commuteProfile_peopleCount_ridesharing";
    ReferenceKey["commuteProfilePeopleCountCarpooling"] = "commuteProfile_peopleCount_carpooling";
    ReferenceKey["commuteProfilePeopleCountVanpool"] = "commuteProfile_peopleCount_vanpool";
    // ATTENTION, THESE NEED TO MATCH THE COMMUTE MODE NAME
    // MAYBE WE SHOULD WORK ON MAKING THIS FOOL PROOF
    ReferenceKey["commuteCostParking"] = "commuteCost_parking";
    ReferenceKey["commuteCostDriving"] = "commuteCost_driving";
    ReferenceKey["commuteCostCarsharing"] = "commuteCost_carsharing";
    ReferenceKey["commuteCostVanpool"] = "commuteCost_vanpool";
    ReferenceKey["commuteCostShuttle"] = "commuteCost_shuttle";
    ReferenceKey["commuteCostBikesharing"] = "commuteCost_bikesharing";
    ReferenceKey["commuteCostSharedScooter"] = "commuteCost_sharedScooter";
    ReferenceKey["commuteCostPublicTransit"] = "commuteCost_public_transit";
    ReferenceKey["commuteCostCarpoolDriver"] = "commuteCost_carpool_driver";
    ReferenceKey["commuteCostCarpoolPassenger"] = "commuteCost_carpool_passenger";
})(ReferenceKey || (exports.ReferenceKey = ReferenceKey = {}));
exports.referenceKeys = Object.values(ReferenceKey);
exports.partnerReferenceKeys = [
    'arc_occupant_satisfaction',
    'arc_occupant_feedbacks',
    'arc_occupant_other_complaints',
    'arc_occupant_location'
];
var PartnerReferenceKey;
(function (PartnerReferenceKey) {
    PartnerReferenceKey["ArcOccupantSatisfaction"] = "arc_occupant_satisfaction";
    PartnerReferenceKey["ArcOccupantFeedbacks"] = "arc_occupant_feedbacks";
    PartnerReferenceKey["ArcOccupantOtherComplaints"] = "arc_occupant_other_complaints";
    PartnerReferenceKey["ArcOccupantLocation"] = "arc_occupant_location";
})(PartnerReferenceKey || (exports.PartnerReferenceKey = PartnerReferenceKey = {}));
//# sourceMappingURL=ReferenceKeys.js.map